import Cookies from 'universal-cookie';
import { SearchRequest, useConfig } from '../../api/api';
import { Box, Button, useTheme, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { SearchField } from './search/SearchField';
import ExoDialog from './ExoDialog';
import { SearchResponseGroup } from './search/SearchResponseGroup';
import SearchIcon from '@mui/icons-material/Search';
import { tokens } from '../../global/theme/tokens';
import { TbSpace } from 'react-icons/tb';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { searchResultMap } from './search/searchResultsMap';

export const ExoSmartSearch = () => {
  const config = useConfig();
  const cookies = new Cookies();
  return (
    <Box>
      {config && (
        <SearchClient
          url={config.searchUrl}
          indexes={cookies.get('searchIndexes')}
        />
      )}
    </Box>
  );
};

const SearchClient = ({ url, indexes }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const cookies = new Cookies();
  const searchPrefix = cookies.get('searchPrefix');
  const location = useLocation();

  const autoFilterMap = {
    /*'/emails': {
      label: t('only emails'),
      Icon: searchResultMap.imap_emails.Icon,
      indexes: [`${searchPrefix}imap_emails`],
    },*/
    '/invoices': {
      label: t('only invoices'),
      Icon: searchResultMap.invoices.Icon,
      indexes: [`${searchPrefix}invoices`],
    },
    '/offers': {
      label: t('only offers'),
      Icon: searchResultMap.offers.Icon,
      indexes: [`${searchPrefix}offers`],
    },
    '/orders': {
      label: t('only orders'),
      Icon: searchResultMap.orders.Icon,
      indexes: [`${searchPrefix}orders`],
    },
    '/leads': {
      label: t('only leads'),
      Icon: searchResultMap.person_leads.Icon,
      indexes: [`${searchPrefix}company_leads`, `${searchPrefix}person_leads`],
    },
    '/expenses': {
      label: t('only expenses'),
      Icon: searchResultMap.person_leads.Icon,
      indexes: [`${searchPrefix}receipts`],
    },
    '/companies': {
      label: t('only companies'),
      Icon: searchResultMap.companies.Icon,
      indexes: [`${searchPrefix}companies`],
    },
    '/contacts': {
      label: t('only contacts'),
      Icon: searchResultMap.contacts.Icon,
      indexes: [`${searchPrefix}contacts`],
    },
  };

  const [open, setOpen] = useState(false);
  const [searchResults, setSearchResults] = useState(null);
  const [currentFilter, setCurrentFilter] = useState(null);

  function search(text) {
    if (!text) return setSearchResults(null);

    var queries = [];
    var indexesToQuery = currentFilter?.indexes || indexes || [];

    indexesToQuery.forEach((index) => {
      queries.push({
        indexUid: index,
        q: text,
      });
    });

    const searchData = { queries };

    SearchRequest({
      baseUrl: url,
      path: 'multi-search',
      method: 'post',
      data: searchData,
      onResponse: (res) => setSearchResults(res.results),
    });
  }

  useEffect(() => {
    setCurrentFilter(autoFilterMap[location.pathname]);

    // Event listener function for keydown event
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.code === 'Space') {
        event.preventDefault(); // Prevent the default behavior of the key combination
        setOpen(!open);
      }
    };
    // Add event listener
    document.addEventListener('keydown', handleKeyDown);

    // Clean up the event listener
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);

  const Icon = currentFilter?.Icon;

  return (
    <Box>
      <Button
        onClick={() => setOpen(true)}
        sx={{
          bgcolor: colors.bgInput,
          ':hover': {
            bgcolor: colors.card,
          },
        }}
      >
        <SearchIcon />
        <Typography className="px-1 hidden md:block">{t('Search')}</Typography>
        <Box className=" justify-center items-center gap-1 pl-4 hidden md:flex opacity-50">
          {t('CTRL')} +
          <TbSpace size={15} />
        </Box>
      </Button>
      <ExoDialog open={open} onClose={() => setOpen(false)}>
        <Box
          className=" max-h-full  w-11/12 flex flex-col mx-auto pt-10 gap-5 "
          sx={{ maxWidth: '750px' }}
        >
          <Box className="flex flex-col gap-2 w-full">
            {currentFilter && (
              <Box className="flex">
                <Box
                  onClick={() => setCurrentFilter(null)}
                  className=" cursor-pointer rounded-lg flex justify-center items-center pl-2 pr-3 gap-2"
                  sx={{
                    backgroundColor: colors.card,
                    minWidth: '35px',
                    minHeight: '35px',
                    height: '40px',
                    border: `1px solid transparent`,
                    ':hover': {
                      bgcolor: colors.error + '30',
                      border: `1px solid ${colors.error}80`,
                    },
                  }}
                >
                  <Icon
                    sx={{
                      fontSize: '25px',
                      color: colors.primary[500],
                    }}
                  />
                  <Typography>{currentFilter.label}</Typography>
                </Box>
              </Box>
            )}
            <SearchField onChange={search} />
          </Box>
          {searchResults && (
            <Box className="w-full max-h-full overflow-y-auto flex flex-col gap-4">
              {searchResults.map((group) => (
                <SearchResponseGroup
                  key={group.indexUid}
                  group={group}
                  onClose={() => setOpen(false)}
                />
              ))}
            </Box>
          )}
        </Box>
      </ExoDialog>
    </Box>
  );
};
